import RentalContactQuery from "./RentalContactQuery";

export default RentalContactQuery;
